import axios from "axios";
import { offlineDb } from "../db/offlineDb";
import { isOnline } from "../utils/network";

const stableStringify = (value) => {
  if (!value || typeof value !== "object") return JSON.stringify(value || {});
  const sorted = Object.keys(value)
    .sort()
    .reduce((acc, key) => {
      acc[key] = value[key];
      return acc;
    }, {});
  return JSON.stringify(sorted);
};

const buildKey = (method, url, payload = {}, params = {}) =>
  `${method.toUpperCase()}::${url}::${stableStringify(payload)}::${stableStringify(params)}`;

const cacheSet = async (key, data) => {
  await offlineDb.api_cache.put({
    key,
    data,
    updated_at: new Date().toISOString(),
  });
};

const cacheGet = async (key) => {
  const row = await offlineDb.api_cache.get(key);
  return row?.data || null;
};

export const cachedGet = async (url, config = {}, forceOffline = false) => {
  const params = config?.params || {};
  const key = buildKey("GET", url, {}, params);

  if (!forceOffline && isOnline()) {
    try {
      const response = await axios.get(url, config);
      await cacheSet(key, response.data);
      return response.data;
    } catch (error) {
      const cached = await cacheGet(key);
      if (cached) return cached;
      throw error;
    }
  }

  const cached = await cacheGet(key);
  if (cached) return cached;
  throw new Error("Offline and no cached data available");
};

export const cachedPostRead = async (url, payload = {}, config = {}, forceOffline = false) => {
  const key = buildKey("POST", url, payload, {});

  if (!forceOffline && isOnline()) {
    try {
      const response = await axios.post(url, payload, config);
      await cacheSet(key, response.data);
      return response.data;
    } catch (error) {
      const cached = await cacheGet(key);
      if (cached) return cached;
      throw error;
    }
  }

  const cached = await cacheGet(key);
  if (cached) return cached;
  throw new Error("Offline and no cached data available");
};

